var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptimizedAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25125 2.04902L2.00125 2.74902L2.70125 1.49902L2.00125 0.249023L3.25125 0.949023L4.50125 0.249023L3.80125 1.49902L4.50125 2.74902L3.25125 2.04902ZM9.25125 6.94902L10.5013 6.24902L9.80125 7.49902L10.5013 8.74902L9.25125 8.04902L8.00125 8.74902L8.70125 7.49902L8.00125 6.24902L9.25125 6.94902ZM10.5013 0.249023L9.80125 1.49902L10.5013 2.74902L9.25125 2.04902L8.00125 2.74902L8.70125 1.49902L8.00125 0.249023L9.25125 0.949023L10.5013 0.249023ZM6.17125 5.63902L7.39125 4.41902L6.33125 3.35902L5.11125 4.57902L6.17125 5.63902ZM6.68625 2.89402L7.85625 4.06402C8.05125 4.24902 8.05125 4.57402 7.85625 4.76902L2.02125 10.604C1.82625 10.799 1.50125 10.799 1.31625 10.604L0.14625 9.43402C-0.04875 9.24902 -0.04875 8.92402 0.14625 8.72902L5.98125 2.89402C6.17625 2.69902 6.50125 2.69902 6.68625 2.89402Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizedAi);
export default __webpack_public_path__ + "static/media/optimized-ai.7bcebf75.svg";
export { ForwardRef as ReactComponent };